<template>
  <div>
    <div class="visual">
      <div class="container">
        <h1>
          ココフォリア
          <span>CoC向けオンラインセッションツール</span>
        </h1>
        <figure @click="countup">
          <img src="../assets/icon.png" alt />
        </figure>
        <p class="note">
          ※こちらは旧ココフォリアです。現在、クトゥルフ神話TRPGだけでなくさまざまなTRPGでもより便利に遊べる新しいココフォリアを試験提供中です。
          <a
            href="https://ccfolia.com"
            target="_blank"
          >https://ccfolia.com</a>
        </p>
        <p>ココフォリアはブラウザから使えるCoC向けオンラインセッションツールです。主にクトゥルフ神話TRPGのセッションをより楽しく、快適に行うための機能が実装されています。</p>
        <p>KPとしてシナリオを進行しつつマップやBGMを切り替え、NPCのRPをこなしつつもあらゆる情報をPLに提示するというのは、リアルタイムにこなすには大変な仕事量です。</p>
        <p>
          ココフォリアでは、プレゼンテーションのスライドを作成するようにあらかじめシーンを作成し、セッション中はワンクリックで画像の配置や音楽を切り替えることができるようになります！
          <a
            class="link"
            href
            target="_blank"
          >>>紹介動画をみる</a>
        </p>
        <a class="btn" href="/app/">早速使ってみる (GoogleChrome推奨)</a>
      </div>
    </div>
    <transition name="popup">
      <div class="thank" v-if="count > 30">
        <div class="container">
          <div class="card">
            <h1>ご支援ありがとうございます。</h1>
            <p>この画面は、Boothにてココフォリアの素材をご購入いただき、ココフォリア開発を支援していただいた方のために用意しています。秘密メモからいらっしゃった方も、たまたま見つけたかたも、どうぞこの画面のことは内密にお願いします。</p>
            <p>隠しリンクとか、キリ番とか、昔楽しかった覚えのあるインターネットのコンテンツをまたやりたくて、こんな形でメッセージを残すことにしてみました。何回もクリックさせてごめんなさい..。</p>
            <p>支援していただいた方に、ささやかですがココフォリア支援者カードというものを用意してみました。カード発行ボタンを押すとナンバリングされたカードが発行されます。(ブラウザによって動かなかったらごめんなさい...) 右クリックから画像を保存してください。このカードの画像自体は、SNS等にシェアしていただいて大丈夫です。</p>
            <p>特に重複を制御していないので、おひとりさま1枚でお願いします！ではでは！感謝を込めて。</p>
            <p>
              <button @click="gen">支援者カード発行</button>
            </p>
            <figure>
              <canvas ref="canvas"></canvas>
            </figure>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { db } from "../modules/firebase/core";
import request from "axios";
import card from "../assets/card.png";

function hex2bin(hex) {
  return ("0000" + parseInt(hex, 16).toString(2)).slice(-4);
}
function bin2hex(bin) {
  if (!bin) return "0";
  return parseInt(bin, 2).toString(16);
}

export default {
  data() {
    return {
      count: 0
      // hex: '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'
    };
  },
  methods: {
    countup() {
      this.$data.count++;
    },
    // gen() {
    //   const { hex } = this.$data
    //   const { canvas } = this.$refs
    //   const array = hex.split('')
    //   const width = 480
    //   const height = 360
    //   const image = new Image()
    //   image.src = card
    //   image.onload = () => {
    //     canvas.width = width
    //     canvas.height = height
    //     const ctx = canvas.getContext('2d')
    //     ctx.drawImage(image, 0, 0, 480, 360)
    //     let c = 0
    //     let ss = ''

    //     const imageDataArray = ctx.getImageData(0, 0, width, height).data
    //     array.forEach((v) => {
    //       const s = hex2bin(v)
    //       ss += s
    //       s.split('').forEach((b) => {
    //         imageDataArray[c*4] = b == 0 ? 255 : 235
    //         imageDataArray[c*4+3] = 255
    //         c++
    //       })
    //     })

    //     const cipheredImageData = new ImageData(imageDataArray, width, height)
    //     ctx.putImageData(cipheredImageData, 0, 0)

    //     const imageData = ctx.getImageData(0, 0, width, height)
    //     const data = imageData.data
    //     let r = ''
    //     let tt = ''

    //     for (let index = 0; index < data.length; index+=(4*4)) {
    //       if (data[index] < 200) {
    //         break
    //       }
    //       let i = 0
    //       let t = ''
    //       while(i < 4) {
    //         const v = data[index + i * 4] > 245 ? 0 : 1
    //         tt += v
    //         if (t || v) {
    //           t += v
    //         }
    //         i++
    //       }
    //       r += bin2hex(t)
    //       // console.log(index)
    //     }
    //   }
    // },
    async gen() {
      const ref = db.collection("aside").doc("event20180914");
      const s1 = await ref.get();
      const n1 = s1.data() ? s1.data().value || 0 : 0;
      const n2 = (n1 || 0) + 1;
      await ref.set({ value: n2 });
      const s2 = await ref.get();
      const n3 = s2.data() ? s2.data().value || 0 : 0;

      const { canvas } = this.$refs;
      const width = 480;
      const height = 360;
      const image = new Image();
      image.src = card;
      image.onload = () => {
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, 480, 360);
        ctx.font = "36px helvetica";
        ctx.fillStyle = "#fff";
        ctx.fillText(`No.${("00000" + n3).slice(-5)}`, 6, 36);
      };
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
body {
  font-family: Arial, Helvetica, sans-serif;
  // background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);
  // background-image: linear-gradient(to top, #30cfd0 0%, #330867 100%);
  background-image: linear-gradient(
    45deg,
    #ff9a9e 0%,
    #fad0c4 99%,
    #fad0c4 100%
  );
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  // background-image: linear-gradient(to top, #37ecba 0%, #72afd3 100%);
}
.container {
  margin: 0 auto;
  max-width: 720px;
  position: relative;
}
.visual {
  padding: 60px 15px;
  color: #400;
  h1 {
    margin-left: 70px;
    font-size: 48px;
    line-height: 1.2;
    span {
      margin-left: 2px;
      margin-left: 5px;
      font-size: 12px;
      line-height: 14px;
      display: block;
    }
  }
  figure {
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 5px;
  }
  figure img {
    width: 60px;
    height: 60px;
  }
  p {
    margin-top: 15px;
    font-size: 14px;
  }
  .note {
    font-size: 24px;
    font-weight: 800;
  }
  .btn {
    margin-top: 30px;
    padding: 15px;
    border: 2px solid #fff;
    display: block;
    color: #fff;
    background: rgba(255, 255, 255, 0);
    text-decoration: none;
    text-align: center;
  }
  .link {
    color: #fff;
    display: none;
  }
  .btn:hover {
    // transition: all 300ms ease-out;
    color: #444;
    background: rgba(255, 255, 255, 1);
  }
}
.thank {
  padding-bottom: 60px;
  color: #444;
  h1 {
    margin-bottom: 15px;
    text-align: center;
    color: #ff6666;
  }
  p {
    font-size: 14px;
  }
  p + p {
    margin-top: 10px;
  }
  .card {
    padding: 30px;
    background: #fff;
  }
  figure {
    margin-top: 15px;
  }
}
.popup-enter-active,
.popup-leave-active {
  transform: scale(1);
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.9);
}
</style>